import { defineStore } from 'pinia'
import { reactive } from 'vue'

type FormState = false | 'submitting' | 'finished' | 'error'

interface FormEntry {
  state: FormState
  message: string | false
}

export const useFormsStore = defineStore('forms', () => {
  const forms = reactive<Record<string, FormEntry>>({})

  function setFormState(formName: string, state: FormState, message: string | false = false) {
    if (!forms[formName]) {
      forms[formName] = { state, message }
    } else {
      forms[formName].state = state
      if (message !== false) {
        forms[formName].message = message
      }
    }
  }

  // Supports dot-notation for nested form keys, e.g. 'consumers.someId'
  function getFormState(formId: string): FormState {
    const entry = formId.split('.').reduce<any>((value, key) => {
      return value && value[key] ? value[key] : null
    }, forms)
    return entry?.state ?? false
  }

  function isFormSubmitting(formId: string): boolean {
    return getFormState(formId) === 'submitting'
  }

  function getFormMessage(formId: string): string | false {
    return forms[formId]?.message ?? false
  }

  return {
    forms,
    setFormState,
    getFormState,
    isFormSubmitting,
    getFormMessage,
  }
})
